import type { CellValue } from "../core/dtype.ts";
import type { AuthId, CalendarId } from "../ids/ids.ts";

/**
 * One calendar a calendar-list alias shows: its account, id, label and events
 * row.
 */
export interface CalendarConfigCalendar {
  readonly authId: AuthId;
  readonly calendarId: CalendarId;
  readonly label: string;
  /** Server-rendered events-row lookup key
   * (`:~{source}:{authId}:calendar:{calId}:events`) — `CalendarDisplay`'s
   * required `eventsLookupKey`. The server owns key construction (provider
   * prefix, primary normalization); the client never builds one. */
  readonly eventsLookupKey: string;
  /** Provider source (`"google"` / `"outlook"`) — `CalendarDisplay.source`. */
  readonly source: string;
}

/** Lists the calendars a calendar-list alias expands into. */
export interface CalendarConfigProvider {
  calendars(): readonly CalendarConfigCalendar[];
}

/**
 * The cell value a calendar-list alias stores for one of its calendars (account, id, label and
 * events row).
 */
export function calendarConfigCell(
  calendar: CalendarConfigCalendar,
): CellValue {
  return {
    authId: calendar.authId,
    calendarId: calendar.calendarId,
    id: calendar.calendarId,
    summary: calendar.label,
    eventsLookupKey: calendar.eventsLookupKey,
    source: calendar.source,
  };
}
